/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
const url = "https://eps.ibpappps.com/eps"; // points to the backend API URL (production environment)
//const url = 'http://localhost:3001/eps'; // points to the backend API URL (local development)

export const apiUrl = (endpoint = '') => {
  return url + endpoint;
};
